import {IDocument} from "../../../modules/ninVerification/types";
import {IPersonProfile} from "../../../app/modules/kyc/person/interfaces/IPersonProfile";
import {ICompanyProfile} from "../../../app/modules/kyc/company/interfaces/ICompanyProfile";

export const STORE_CRM_COMPANY_CONSTANTS = {
    workflowsStartFetch: "CRM_COMPANY_START_FETCH",
    workflowsStopFetch: "CRM_COMPANY_STOP_FETCH",
    workflowsCommitFetch: "CRM_COMPANY_COMMIT_FETCH",
    workflowsReceiveProfile: "CRM_PERSON_RECEIVE_PROFILE",
    companyUpdateDocuments: "CRM_COMPANY_UPDATE_DOCUMENTS",
    RESET: "RESET",
    ToggleDocumentPreviewer: "TOGGLE_DOCUMENT_PREVIEWER"
}

export interface ICompanyCrmWorkflowState {
    loading: boolean
    data?: ICompanyProfile
    documents?: [],
    openDocumentPreviewer: false,
}

const initialState: ICompanyCrmWorkflowState = {
    data: undefined,
    loading: false,
    documents: [],
    openDocumentPreviewer: false,
}

export default function reducer(state = initialState, action: any) {
    switch (action.type) {

        case STORE_CRM_COMPANY_CONSTANTS.workflowsStartFetch: {
            return {...state, loading: true}
        }
        case STORE_CRM_COMPANY_CONSTANTS.workflowsStopFetch: {
            return {...state, loading: false}
        }

        case STORE_CRM_COMPANY_CONSTANTS.workflowsCommitFetch: {
            return {...state, data: action.payload, loading: false}
        }

        case STORE_CRM_COMPANY_CONSTANTS.RESET: {
            return {...state, data: undefined, loading: false}
        }

        case STORE_CRM_COMPANY_CONSTANTS.companyUpdateDocuments: {
            return {...state, documents: action.payload}
        }

        case STORE_CRM_COMPANY_CONSTANTS.ToggleDocumentPreviewer: {
            return {...state, openDocumentPreviewer: action.payload}
        }

        case STORE_CRM_COMPANY_CONSTANTS.workflowsReceiveProfile: {

            if (state.data && state.data.id === action.payload.id) {
                return {...state, data: action.payload, loading: false}
            }
            return state
        }

        default: {
            return state
        }
    }
}

export function startWorkflowFetch() {
    return {type: STORE_CRM_COMPANY_CONSTANTS.workflowsStartFetch}
}